import ComponentConsumptions from './ComponentConsumptions';
export default ComponentConsumptions;
